
import { SET_UNAUTHENTICATED, MEMBER_LIST,
  LOADING_USER,
  INVOICE_LIST,
  LOADER_CHECK,
  } from '../type'

const initialState = {
 invoiceData:[]    
}

export default function (state = initialState, action) {
  switch (action.type) {
      case SET_UNAUTHENTICATED:
          return initialState;
      case INVOICE_LIST:
          return {
              ...state,
              invoiceData: action.payload,
              loading: false
          }
      default:
          return state; 
  }
}
